import { render, staticRenderFns } from "./DepartureBoard.vue?vue&type=template&id=46e68737&"
import script from "./DepartureBoard.vue?vue&type=script&lang=js&"
export * from "./DepartureBoard.vue?vue&type=script&lang=js&"
import style0 from "./DepartureBoard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports